export const translations = {
  pt: {
    meta: {
      title: 'Havel br — Apps que Transformam o Seu Dia',
      description:
        'Havel br — Estúdio brasileiro de aplicativos. Criamos jogos, ferramentas de produtividade e apps de bem-estar que entram na sua rotina — e ficam para sempre.',
    },
    nav: { apps: 'Apps', about: 'Sobre', contact: 'Contato', cta: 'Fale conosco' },
    hero: {
      eyebrow: 'Desenvolvimento de Aplicativos · Brasil',
      titleBefore: 'Apps que ',
      titleHighlight: 'transformam',
      titleAfter: ' o seu dia',
      desc:
        'Criamos jogos, ferramentas de produtividade e apps de bem-estar que entram na sua rotina — e ficam para sempre.',
      primary: 'Ver nossos apps',
      secondary: 'Sobre nós',
    },
    stats: [
      { val: '10+', label: ['Apps no', 'Google Play'] },
      { val: '50K+', label: ['Downloads', 'acumulados'] },
      { val: '4.8★', label: ['Avaliação média', 'na loja'] },
    ],
    apps: {
      eyebrow: 'Nossos Aplicativos',
      title: 'Feitos para o dia a dia',
      sub:
        'De jogos envolventes a ferramentas de organização e cuidado com a mente — cada app é pensado para gerar valor real.',
      comingLabel: 'Em desenvolvimento',
      soon: 'Em breve',
      items: [
        { cat: 'Jogo de Palavras', name: 'Termo! Jogo de Palavras Diário', desc: 'Jogo no estilo Wordle. Disponível em 6 idiomas.' },
        { cat: 'Produtividade', name: 'Organizador de Agenda', desc: 'Gerencie sua rotina com facilidade. Lembretes, compromissos e metas reunidos num só lugar.' },
        { cat: 'Utilidades', name: 'Lista de Compras', desc: 'Monte listas rapidamente, compartilhe com a família e nunca esqueça nada no mercado.' },
        { cat: 'Saúde Mental', name: 'Bem-Estar', desc: 'Cuide da sua saúde mental com exercícios de mindfulness, diário de humor e check-ins diários.' },
      ],
      coming: [],
    },
    pillars: {
      eyebrow: 'O Que Fazemos',
      title: 'Três pilares, um propósito',
      items: [
        { title: 'Jogos', desc: 'Jogos pensados para entreter de verdade — desafiadores, viciantes e feitos para durar além do primeiro download.' },
        { title: 'Produtividade', desc: 'Ferramentas simples que cabem na rotina: organize compromissos, listas e tarefas sem complicação.' },
        { title: 'Bem-Estar', desc: 'Apps que colocam a saúde mental no centro — porque cuidar de si mesmo é a base de tudo.' },
      ],
    },
    about: {
      eyebrow: 'Sobre nós',
      title: 'Criamos com propósito',
      paragraphs: [
        'Somos um estúdio independente focado em criar aplicativos que realmente importam para as pessoas. Cada projeto nasce de uma necessidade real — e é desenvolvido com atenção a cada detalhe.',
        'Nosso portfólio vai de jogos cativantes a apps de produtividade e saúde mental. O que une tudo isso é o compromisso com a qualidade e a experiência do usuário.',
      ],
      cta: 'Fale conosco',
      orb: ['Feitos no', 'Brasil 🇧🇷'],
    },
    footer: {
      tagline: 'Apps que entram na sua rotina — e ficam.',
      navTitle: 'Navegação',
      legalTitle: 'Legal',
      contactTitle: 'Contato',
      gplay: 'Google Play',
      legalHub: 'Documentos legais',
      privacyOf: (app) => `Privacidade — ${app}`,
      location: 'Brasil 🇧🇷',
      rights: '© 2026 Havel br. Todos os direitos reservados.',
    },
    legal: {
      hubTitle: 'Documentos Legais',
      hubIntro:
        'Aqui você encontra a Política de Privacidade e os Termos de Uso de cada um dos nossos aplicativos.',
      back: '← Todos os documentos',
      loading: 'Carregando…',
      error: 'Não foi possível carregar este documento. Tente novamente mais tarde ou escreva para',
      docTypes: { privacidade: 'Política de Privacidade', termos: 'Termos de Uso' },
      projects: {
        termo: 'Jogo de adivinhação de palavras',
        lume: 'Bem-estar e autocuidado',
        julius: 'Gestão de finanças pessoais',
      },
    },
  },

  en: {
    meta: {
      title: 'Havel br — Apps That Transform Your Day',
      description:
        'Havel br — Brazilian app studio. We build games, productivity tools and wellbeing apps that become part of your routine — and stay for good.',
    },
    nav: { apps: 'Apps', about: 'About', contact: 'Contact', cta: 'Get in touch' },
    hero: {
      eyebrow: 'App Development · Brazil',
      titleBefore: 'Apps that ',
      titleHighlight: 'transform',
      titleAfter: ' your day',
      desc:
        'We build games, productivity tools and wellbeing apps that become part of your routine — and stay for good.',
      primary: 'See our apps',
      secondary: 'About us',
    },
    stats: [
      { val: '10+', label: ['Apps on', 'Google Play'] },
      { val: '50K+', label: ['Total', 'downloads'] },
      { val: '4.8★', label: ['Average store', 'rating'] },
    ],
    apps: {
      eyebrow: 'Our Apps',
      title: 'Made for everyday life',
      sub:
        'From engaging games to tools for organizing and caring for your mind — every app is built to deliver real value.',
      comingLabel: 'In development',
      soon: 'Coming soon',
      items: [
        { cat: 'Word Game', name: 'Termo! Daily Word Game', desc: 'Wordle-style word game. Available in 6 languages.' },
        { cat: 'Productivity', name: 'Schedule Organizer', desc: 'Manage your routine with ease. Reminders, appointments and goals all in one place.' },
        { cat: 'Utilities', name: 'Shopping List', desc: 'Build lists in seconds, share them with your family and never forget anything at the store.' },
        { cat: 'Mental Health', name: 'Wellbeing', desc: 'Take care of your mental health with mindfulness exercises, a mood journal and daily check-ins.' },
      ],
      coming: [],
    },
    pillars: {
      eyebrow: 'What We Do',
      title: 'Three pillars, one purpose',
      items: [
        { title: 'Games', desc: 'Games built to truly entertain — challenging, addictive and made to last well beyond the first download.' },
        { title: 'Productivity', desc: 'Simple tools that fit your routine: organize appointments, lists and tasks without the hassle.' },
        { title: 'Wellbeing', desc: 'Apps that put mental health front and center — because taking care of yourself is the foundation of everything.' },
      ],
    },
    about: {
      eyebrow: 'About us',
      title: 'We build with purpose',
      paragraphs: [
        'We are an independent studio focused on building apps that truly matter to people. Every project is born from a real need — and crafted with attention to every detail.',
        'Our portfolio ranges from captivating games to productivity and mental health apps. What ties it all together is our commitment to quality and user experience.',
      ],
      cta: 'Get in touch',
      orb: ['Made in', 'Brazil 🇧🇷'],
    },
    footer: {
      tagline: 'Apps that become part of your routine — and stay.',
      navTitle: 'Navigation',
      legalTitle: 'Legal',
      contactTitle: 'Contact',
      gplay: 'Google Play',
      legalHub: 'Legal documents',
      privacyOf: (app) => `Privacy — ${app}`,
      location: 'Brazil 🇧🇷',
      rights: '© 2026 Havel br. All rights reserved.',
    },
    legal: {
      hubTitle: 'Legal Documents',
      hubIntro:
        'Here you will find the Privacy Policy and Terms of Use for each of our apps.',
      back: '← All documents',
      loading: 'Loading…',
      error: 'This document could not be loaded. Please try again later or write to',
      docTypes: { privacidade: 'Privacy Policy', termos: 'Terms of Use' },
      projects: {
        termo: 'Word-guessing game',
        lume: 'Wellbeing and self-care',
        julius: 'Personal finance management',
      },
    },
  },
};
